<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :close-on-click-modal="true"
    :show-close="true"
    center
    class="login-choice-dialog"
    @close="handleClose"
  >
    <div class="login-choice-content">
      <div class="login-header">
        <div class="login-choice-title">
          <span class="title-icon">🔐</span>
          <span class="title-text">SIGN IN</span>
        </div>
        <div class="login-subtitle">{{ $t('h.pleaseChooseLoginType') || '请选择登录方式' }}</div>
      </div>
      <div class="login-choice-grid">
        <div class="login-card student" @click="chooseStudentLogin">
          <div class="card-background"></div>
          <div class="card-content">
            <div class="card-icon-wrapper">
              <div class="card-icon student">
                <i class="el-icon-user"></i>
              </div>
              <div class="icon-glow student"></div>
            </div>
            <div class="card-info">
              <div class="card-title">{{ $t('h.studentLogin') }}</div>
              <div class="card-desc">{{ $t('h.studentLoginDesc') || '学生用户登录入口' }}</div>
            </div>
            <div class="card-arrow-wrapper">
              <i class="el-icon-arrow-right card-arrow"></i>
            </div>
          </div>
          <div class="card-decoration student"></div>
        </div>
        <div class="login-card partner" @click="choosePartnerLogin">
          <div class="card-background"></div>
          <div class="card-content">
            <div class="card-icon-wrapper">
              <div class="card-icon partner">
                <i class="el-icon-s-custom"></i>
              </div>
              <div class="icon-glow partner"></div>
            </div>
            <div class="card-info">
              <div class="card-title">{{ $t('h.partnerLogin') }}</div>
              <div class="card-desc">{{ $t('h.partnerLoginDesc') || '合作机构登录入口' }}</div>
            </div>
            <div class="card-arrow-wrapper">
              <i class="el-icon-arrow-right card-arrow"></i>
            </div>
          </div>
          <div class="card-decoration partner"></div>
        </div>
        <div class="login-card teacher" @click="chooseTeacherLogin" v-if="false">
          <div class="card-background"></div>
          <div class="card-content">
            <div class="card-icon-wrapper">
              <div class="card-icon teacher">
                <i class="el-icon-suitcase"></i>
              </div>
              <div class="icon-glow teacher"></div>
            </div>
            <div class="card-info">
              <div class="card-title">{{ $t('h.teacherLogin') }}</div>
              <div class="card-desc">{{ $t('h.teacherLoginDesc') || '教师用户登录入口' }}</div>
            </div>
            <div class="card-arrow-wrapper">
              <i class="el-icon-arrow-right card-arrow"></i>
            </div>
          </div>
          <div class="card-decoration teacher"></div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LoginChoiceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 是否启用教师端入口（默认隐藏，传入 true 时显示）
    showTeacher: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogWidth: '480px'
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  mounted () {
    this.calcWidth()
    window.addEventListener('resize', this.calcWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcWidth)
  },
  methods: {
    calcWidth () {
      const w = window.innerWidth
      if (w <= 320) {
        this.dialogWidth = '94%'
      } else if (w <= 768) {
        this.dialogWidth = '94%'
      } else if (w <= 1024) {
        this.dialogWidth = '66%'
      } else {
        this.dialogWidth = '50%'
      }
    },
    handleClose () {
      this.$emit('close')
    },
    // 关闭弹窗并触发学生登录事件
    chooseStudentLogin () {
      this.dialogVisible = false
      this.$emit('student')
    },
    // 关闭弹窗并触发合作机构登录事件
    choosePartnerLogin () {
      this.dialogVisible = false
      this.$emit('partner')
    },
    // 关闭弹窗并触发教师登录事件
    chooseTeacherLogin () {
      this.dialogVisible = false
      this.$emit('teacher')
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .login-choice-dialog {
  .el-dialog {
    border-radius: 24px;
    overflow: visible;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    width: 480px !important;
    min-width: 480px;
  }
  .el-dialog__header {
    display: none;
    padding: 0;
  }
  .el-dialog__body {
    padding: 0 !important;
    background: transparent;
    overflow: visible;
    min-height: 300px;
  }
  .el-dialog__close {
    z-index: 10;
    color: #666;
    font-size: 20px;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    &:hover {
      color: #b81c25;
    }
  }
}

.login-choice-content {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 200px;
}

.login-header {
  padding: 32px 32px 24px;
  text-align: center;
  background: linear-gradient(135deg, rgba(184, 28, 37, 0.05) 0%, rgba(248, 189, 29, 0.05) 100%);
  position: relative;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #b81c25 0%, #f8bd1d 50%, #b81c25 100%);
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }
}

.login-choice-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;

  .title-icon {
    font-size: 28px;
    animation: pulse 2s ease-in-out infinite;
  }

  .title-text {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #b81c25 0%, #f8bd1d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: 2px;
  }
}

.login-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 4px;
}

.login-choice-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 24px 32px 32px;
}

.login-card {
  position: relative;
  border-radius: 16px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);

    .card-background {
      opacity: 1;
    }

    .card-icon {
      transform: scale(1.1) rotate(5deg);
    }

    .icon-glow {
      opacity: 0.6;
      transform: scale(1.3);
    }

    .card-arrow {
      transform: translateX(6px);
    }

    .card-decoration {
      opacity: 1;
      transform: scale(1);
    }
  }

  &.student {
    &:hover {
      border-color: rgba(184, 28, 37, 0.3);
      box-shadow: 0 12px 32px rgba(184, 28, 37, 0.2);
    }
  }

  &.partner {
    &:hover {
      border-color: rgba(248, 189, 29, 0.3);
      box-shadow: 0 12px 32px rgba(248, 189, 29, 0.2);
    }
  }

  &.teacher {
    &:hover {
      border-color: rgba(76, 175, 80, 0.3);
      box-shadow: 0 12px 32px rgba(76, 175, 80, 0.2);
    }
  }
}

.card-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s ease;

  .student & {
    background: linear-gradient(135deg, rgba(184, 28, 37, 0.05) 0%, rgba(211, 47, 47, 0.05) 100%);
  }

  .partner & {
    background: linear-gradient(135deg, rgba(248, 189, 29, 0.05) 0%, rgba(255, 213, 79, 0.05) 100%);
  }

  .teacher & {
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(102, 187, 106, 0.05) 100%);
  }
}

.card-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  z-index: 2;
}

.card-icon-wrapper {
  position: relative;
  flex-shrink: 0;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;

  &.student {
    background: linear-gradient(135deg, #b81c25 0%, #d32f2f 100%);
    box-shadow: 0 8px 20px rgba(184, 28, 37, 0.3);
  }

  &.partner {
    background: linear-gradient(135deg, #f8bd1d 0%, #ffd54f 100%);
    color: #8a5b00;
    box-shadow: 0 8px 20px rgba(248, 189, 29, 0.3);
  }

  &.teacher {
    background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
    color: #fff;
    box-shadow: 0 8px 20px rgba(76, 175, 80, 0.3);
  }
}

.icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  width: 56px;
  height: 56px;
  border-radius: 16px;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 1;

  &.student {
    background: radial-gradient(circle, rgba(184, 28, 37, 0.4) 0%, transparent 70%);
  }

  &.partner {
    background: radial-gradient(circle, rgba(248, 189, 29, 0.4) 0%, transparent 70%);
  }

  &.teacher {
    background: radial-gradient(circle, rgba(76, 175, 80, 0.4) 0%, transparent 70%);
  }
}

.card-info {
  flex: 1;
  min-width: 0;

  .card-title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 4px;
    line-height: 1.4;
  }

  .card-desc {
    font-size: 13px;
    color: #999;
    line-height: 1.4;
  }
}

.card-arrow-wrapper {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.card-arrow {
  font-size: 18px;
  color: #666;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s ease;
}

.login-card:hover .card-arrow-wrapper {
  background: rgba(184, 28, 37, 0.1);
}

.login-card:hover .card-arrow {
  color: #b81c25;
}

.card-decoration {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.3s ease;
  z-index: 1;

  &.student {
    background: radial-gradient(circle, rgba(184, 28, 37, 0.1) 0%, transparent 70%);
  }

  &.partner {
    background: radial-gradient(circle, rgba(248, 189, 29, 0.1) 0%, transparent 70%);
  }

  &.teacher {
    background: radial-gradient(circle, rgba(76, 175, 80, 0.1) 0%, transparent 70%);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

// 移动端适配
@media (max-width: 768px) {
  ::v-deep .login-choice-dialog {
    .el-dialog {
      border-radius: 24px;
      margin: auto !important;
      width: 94% !important;
      min-width: 420px !important;
      max-width: 680px;
      position: relative;
      top: 50% !important;
      transform: translateY(-50%);
      max-height: 90vh;
      display: flex;
      flex-direction: column;
    }
    .el-dialog__body {
      padding: 0;
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .el-dialog__close {
      font-size: 26px;
      width: 48px;
      height: 48px;
      line-height: 48px;
      z-index: 10;
    }
  }

  .login-choice-content {
    min-height: 0;
  }
}

// 平板适配
@media (min-width: 769px) and (max-width: 1024px) {
  ::v-deep .login-choice-dialog {
    .el-dialog {
      max-width: 66%;
    }
    .el-dialog__close {
      font-size: 26px;
      width: 44px;
      height: 44px;
      line-height: 44px;
    }
  }

  .login-header {
    padding: 28px 24px 22px;
  }
}
</style>
